exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-search {\n  width: -webkit-fill-available; }\n\n.dropdown-search-input {\n  padding-bottom: 0px; }\n\n.dropdown-search-input .form-control-feedback {\n  opacity: 1; }\n\n.form-group {\n  margin: 0px; }\n\n#dropdown-basic .form-group .form-control {\n  padding-bottom: 10px;\n  margin: 8px 0 0 0 !important; }\n\n.label-on-left {\n  padding: 28px 5px 0 0;\n  text-align: right; }\n\n.label-on-right {\n  padding: 28px 0 0 5px;\n  text-align: left; }\n\n@media (max-width: 991px) {\n  .label-on-right, .label-on-left {\n    padding-left: 15px;\n    padding-top: 8px; } }\n\n.btn-clear {\n  padding: 20px 0px 0px 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/call/list/calls.component.scss
// module id = ../../../../../src/app/client/call/list/calls.component.scss
// module chunks = 0